import { IActiveTabData, IState, IWorkspaceTabs } from "@/lib/widgetsLayoutDir";
import { create } from "zustand";

export type State = {
  workspacesTabs: IWorkspaceTabs[];
  widgetsAvailable: string[];
  tabNamesAndActive: IActiveTabData[];
};

type Action = {
  // eslint-disable-next-line no-unused-vars
  setWorkspacesTabs: (workspacesTabs: State["workspacesTabs"]) => void;
  // eslint-disable-next-line no-unused-vars
  setTabNamesAndActive: (tabNamesAndActive: State["tabNamesAndActive"]) => void;
  // eslint-disable-next-line no-unused-vars
  updateWholeTab: (layout: IState, idOfActiveTab: number) => void;
  // eslint-disable-next-line no-unused-vars
  setWidgetsAvailable: (widgetsAvailable: State["widgetsAvailable"]) => void;
};

const workspacesTabsStore = create<State & Action>((set) => ({
  workspacesTabs: [],
  widgetsAvailable: [],
  setWorkspacesTabs: (incomingData) => {
    set(() => ({
      workspacesTabs: incomingData,
    }));
  },
  tabNamesAndActive: [],
  setTabNamesAndActive: (incomingData) => {
    set(() => ({
      tabNamesAndActive: incomingData,
    }));
  },
  updateWholeTab: (incomingData, idOfActiveTab) => {
    set((state) => {
      const newStateJson = JSON.stringify(incomingData);
      const targetTab = state.workspacesTabs.find(
        (tab) => tab.tabId == idOfActiveTab,
      );

      // LQC-1837: bail out on an identical payload. Notifying subscribers re-renders RGL,
      // which re-emits onLayoutChange and saves again - that is the flicker loop.
      if (!targetTab || targetTab.stateJson === newStateJson) return state;

      // Replace the tab object rather than mutating it, so earlier reads stay snapshots.
      return {
        workspacesTabs: state.workspacesTabs.map((tab) =>
          tab.tabId == idOfActiveTab
            ? { ...tab, stateJson: newStateJson }
            : tab,
        ),
      };
    });
  },
  setWidgetsAvailable: (IncomingData) => {
    set(() => ({
      widgetsAvailable: IncomingData,
    }));
  },
}));

export default workspacesTabsStore;
